export function requestUserPasswordResetToken(apiUrl, accessToken, user, email) {
  if (typeof accessToken !== 'string') {
    throw new Error(
      `[requestUserPasswordResetToken] Expected accessToken string, got ${typeof accessToken}`
    );
  }

  return fetch(`${apiUrl}/v1/userInfo/password/token`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, username: user }),
  })
}

export function updateUserPassword(apiUrl, accessToken, userId, newPassword, pwResetToken) {

    return fetch(`${apiUrl}/v1/userInfo/${userId}/password`, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: pwResetToken,
        newPassword,
      }),
    });
}

export function getUserInfo(apiUrl, accessToken, userId) {
  if (typeof accessToken !== 'string') {
    throw new Error(
      `[getUserInfo] Expected accessToken string, got ${typeof accessToken}`
    );
  }

  if (!userId || typeof userId !== 'string') {
    throw new Error(
      `[getUserInfo] Expected userId string, got ${typeof userId}`
    );
  }

  return fetch(`${apiUrl}/v1/userInfo/${userId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
}
